const basePath = '/personal/class-rooms'
export const ROUTER_PERSONAL_CLASS_ROOM = {
	root: `${basePath}`,
	home: alias => `${basePath}/${alias || ':alias'}`
}
